import React from 'react';
import { View } from 'react-native';
import Title from '../Text/Title';

const SortCard = ({
  step,
}) => (
  <View key={step}>
    <Title>
      {step}
    </Title>
  </View>
);

export default SortCard;
